import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { stockBadge, DISCONTINUED } from '../../lib/fabricLabels';

const Tip = ({ label, className, side, children, testId }) => (
  <TooltipProvider delayDuration={80}>
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className={`text-[10px] font-medium px-2 py-1 border-0 ${className}`} data-testid={testId}>{label}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

// Stock dot + optional red "discontinued" exclamation; both labels only appear on hover.
export const StockDot = ({ status, discontinued = false, size = 'md', className = '', testId, side = 'top' }) => {
  const opt = stockBadge(status);
  if (!opt && !discontinued) return null;
  const dim = size === 'sm' ? 'w-2 h-2' : size === 'lg' ? 'w-3.5 h-3.5' : 'w-2.5 h-2.5';
  const iconDim = size === 'sm' ? 'w-3 h-3' : size === 'lg' ? 'w-[18px] h-[18px]' : 'w-3.5 h-3.5';
  const stop = { onClick: (e) => e.stopPropagation(), onDoubleClick: (e) => e.stopPropagation() };
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid={testId} data-stock={status || ''} data-discontinued={discontinued ? 'true' : 'false'} {...stop}>
      {opt && (
        <Tip label={opt.label} className={opt.className} side={side} testId={testId ? `${testId}-tooltip` : undefined}>
          <span className="inline-flex cursor-default" aria-label={opt.label} data-testid={testId ? `${testId}-dot` : undefined}>
            <span className={`${dim} rounded-full ring-2 ring-white shadow ${opt.dot} block`} />
            <span className="sr-only" data-testid={testId ? `${testId}-label` : undefined}>{opt.label}</span>
          </span>
        </Tip>
      )}
      {discontinued && (
        <Tip label={DISCONTINUED.label} className={DISCONTINUED.className} side={side} testId={testId ? `${testId}-discontinued-tooltip` : undefined}>
          <span className="inline-flex cursor-default" aria-label={DISCONTINUED.label} data-testid={testId ? `${testId}-discontinued` : undefined}>
            <AlertCircle className={`${iconDim} text-red-600 bg-white rounded-full shadow`} strokeWidth={2.5} />
            <span className="sr-only">{DISCONTINUED.label}</span>
          </span>
        </Tip>
      )}
    </span>
  );
};

export default StockDot;
